import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		searchBar: {
			backgroundColor: "white",
			borderRadius: 4,
			padding: "5px 20px",
		},
		filter: {
			textAlign: "right"
		},
		filterMobileButton: {
			paddingLeft: 2,
			paddingRight: 2,
		},
		filterIcon: {
			marginTop: "2px",
			marginBottom: "2px",
		},
		dropdownButton: {
			display: "flex",
			flexDirection: "row",
			alignItems: "center",
			textTransform: "none",
		},
		idButton: {
			borderRadius: 20,
			"&:hover": {
				backgroundColor: "#DCDCDC",
			},
		},
		marketLink: {
			textDecoration: "none"
		},
		marketText: {
			maxWidth: 350
		},
		helperTextStyle: {
			color: "red",
			margin: 0
		},
		alertCircle: {
			height: 20,
			position: "relative",
			right: 5,
			top: 2
		},
		contentSearchBar: {
			width: "29rem",
			maxWidth: "29rem",
			height: "2.5rem",
			backgroundColor: "white",
			border: "1px solid #ebebeb",
			borderRadius: 4,
			padding: "0.5rem 1rem",
			fontSize: "1rem",
			fontFamily: theme.typography.fontFamily,
		},
		contentSearchBarIcon: {
			color: theme.palette.primary.main,
		},
	} satisfies Record<string, CSSObject>;
};
